

import { computed, ref } from 'vue'
import moment from 'moment';
import {FilterMatchMode, FilterOperator} from "primevue/api";
import router from "@/router";
import {useToast} from "primevue/usetoast";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useConfirm } from "primevue/useconfirm";
import {BaoCaoCoSoLaoDong} from "@/models/baoCaoCoSoLaoDong";
import {ThongTinLaoDong} from "@/models/thongTinLaoDong";
import CDCRepository from "@/services/CDCRepository";
import {DanhSachBaoCaoThang} from "@/models/danhSachBaoCaoThang";
import axios from "axios";


export default {
  setup() {
    const confirm = useConfirm();
    const toast = useToast();
    const store = useStore();
    const date = ref();
    const service = ref("");
    const router = useRouter();
    const baoCaoCoSoLaoDong = ref({} as BaoCaoCoSoLaoDong);
    const listBaoCao = ref([] as DanhSachBaoCaoThang[]);
    console.log("####################@@@@@@@@@@@@@@@@@@@@@ baoCaoCoSoLaoDong aaaa: ");
    console.log("####################@@@@@@@@@@@@@@@@@@@@@ baoCaoCoSoLaoDong baoCaoCoSoLaoDong.value: " + baoCaoCoSoLaoDong.value.lamCongTacYTe);
    const initDb = () => {
      baoCaoCoSoLaoDong.value.nguoiLaoDongs = [
        {noiDung: "Tổng số người lao động"},
        {noiDung: "Số lao động trực tiếp sản xuất"},
        {noiDung: "Số lao động làm nghề, công việc nặng nhọc độc hại nguy hiểm và đặc biệt NNĐHNH"},
      ]
      baoCaoCoSoLaoDong.value.thongTinLaoDongs = [
        {hoVaTen: ""},
        {hoVaTen: ""},
        {hoVaTen: ""},
      ]
      baoCaoCoSoLaoDong.value.kiemTraVeSinhLaoDongs = [
        {donViKiemTra: ""},
        {donViKiemTra: ""},
        {donViKiemTra: ""},
      ]
      baoCaoCoSoLaoDong.value.dieuKienLaoDongs = [
        {yeuToQuanTrac: "Nhiệt độ", tongSoMaus: {bui: false}, soMauKhongDats: {bui: false}, },
        {yeuToQuanTrac: "Độ ẩm", tongSoMaus: {bui: false}, soMauKhongDats: {bui: false}, },
        {yeuToQuanTrac: "Tốc độ gió", tongSoMaus: {bui: false}, soMauKhongDats: {bui: false}, },
        {yeuToQuanTrac: "Bức xạ nhiệt", tongSoMaus: {bui: false}, soMauKhongDats: {bui: false}, },
        {yeuToQuanTrac: "Ánh sáng", tongSoMaus: {bui: false}, soMauKhongDats: {bui: false}, },
        {yeuToQuanTrac: "Bụi toàn phần", tongSoMaus: {bui: true}, soMauKhongDats: {bui: true}, },
        {yeuToQuanTrac: "Bụi hô hấp", tongSoMaus: {bui: true}, soMauKhongDats: {bui: true}, },
        {yeuToQuanTrac: "Các loại bụi khác", tongSoMaus: {bui: true}, soMauKhongDats: {bui: true}, },
        {yeuToQuanTrac: "Ồn", tongSoMaus: {bui: false}, soMauKhongDats: {bui: false}, },
        {yeuToQuanTrac: "Rung", tongSoMaus: {bui: false}, soMauKhongDats: {bui: false}, },
        {yeuToQuanTrac: "Hơi khí độc", tongSoMaus: {bui: false}, soMauKhongDats: {bui: false}, },
        {yeuToQuanTrac: "Phóng xạ", tongSoMaus: {bui: false}, soMauKhongDats: {bui: false}, },
        {yeuToQuanTrac: "Điện từ trường", tongSoMaus: {bui: false}, soMauKhongDats: {bui: false}, },
        {yeuToQuanTrac: "Yếu tố TXNN", tongSoMaus: {bui: false}, soMauKhongDats: {bui: false}, },
        {yeuToQuanTrac: "Đánh giá TSL và ec-gô-nô-my", tongSoMaus: {bui: false}, soMauKhongDats: {bui: false}, },
        {yeuToQuanTrac: "Các yếu tố khác", tongSoMaus: {bui: false}, soMauKhongDats: {bui: false}, },
      ]

      baoCaoCoSoLaoDong.value.nghiViecDoOms = [
        {quy: "Quý I", thang: "1",oms: {soNguoi: 0, tongSoNgay: 0},taiNanLaoDongs: {soNguoi: 0, tongSoNgay: 0},benhNgheNghieps: {soNguoi: 0, tongSoNgay: 0} ,tongSos: {soNguoi: 0, tongSoNgay: 0}, },
        {quy: "Quý I", thang: "2",oms: {soNguoi: 0, tongSoNgay: 0},taiNanLaoDongs: {soNguoi: 0, tongSoNgay: 0},benhNgheNghieps: {soNguoi: 0, tongSoNgay: 0} ,tongSos: {soNguoi: 0, tongSoNgay: 0}, },
        {quy: "Quý I", thang: "3",oms: {soNguoi: 0, tongSoNgay: 0},taiNanLaoDongs: {soNguoi: 0, tongSoNgay: 0},benhNgheNghieps: {soNguoi: 0, tongSoNgay: 0} ,tongSos: {soNguoi: 0, tongSoNgay: 0}, },
        {quy: "Quý II", thang: "4",oms: {soNguoi: 0, tongSoNgay: 0},taiNanLaoDongs: {soNguoi: 0, tongSoNgay: 0},benhNgheNghieps: {soNguoi: 0, tongSoNgay: 0} ,tongSos: {soNguoi: 0, tongSoNgay: 0}, },
        {quy: "Quý II", thang: "5",oms: {soNguoi: 0, tongSoNgay: 0},taiNanLaoDongs: {soNguoi: 0, tongSoNgay: 0},benhNgheNghieps: {soNguoi: 0, tongSoNgay: 0} ,tongSos: {soNguoi: 0, tongSoNgay: 0}, },
        {quy: "Quý II", thang: "6",oms: {soNguoi: 0, tongSoNgay: 0},taiNanLaoDongs: {soNguoi: 0, tongSoNgay: 0},benhNgheNghieps: {soNguoi: 0, tongSoNgay: 0} ,tongSos: {soNguoi: 0, tongSoNgay: 0}, },
        {quy: "Quý III", thang: "7",oms: {soNguoi: 0, tongSoNgay: 0},taiNanLaoDongs: {soNguoi: 0, tongSoNgay: 0},benhNgheNghieps: {soNguoi: 0, tongSoNgay: 0} ,tongSos: {soNguoi: 0, tongSoNgay: 0}, },
        {quy: "Quý III", thang: "8",oms: {soNguoi: 0, tongSoNgay: 0},taiNanLaoDongs: {soNguoi: 0, tongSoNgay: 0},benhNgheNghieps: {soNguoi: 0, tongSoNgay: 0} ,tongSos: {soNguoi: 0, tongSoNgay: 0}, },
        {quy: "Quý III", thang: "9",oms: {soNguoi: 0, tongSoNgay: 0},taiNanLaoDongs: {soNguoi: 0, tongSoNgay: 0},benhNgheNghieps: {soNguoi: 0, tongSoNgay: 0} ,tongSos: {soNguoi: 0, tongSoNgay: 0}, },
        {quy: "Quý IV", thang: "10",oms: {soNguoi: 0, tongSoNgay: 0},taiNanLaoDongs: {soNguoi: 0, tongSoNgay: 0},benhNgheNghieps: {soNguoi: 0, tongSoNgay: 0} ,tongSos: {soNguoi: 0, tongSoNgay: 0}, },
        {quy: "Quý IV", thang: "11",oms: {soNguoi: 0, tongSoNgay: 0},taiNanLaoDongs: {soNguoi: 0, tongSoNgay: 0},benhNgheNghieps: {soNguoi: 0, tongSoNgay: 0} ,tongSos: {soNguoi: 0, tongSoNgay: 0}, },
        {quy: "Quý IV", thang: "12",oms: {soNguoi: 0, tongSoNgay: 0},taiNanLaoDongs: {soNguoi: 0, tongSoNgay: 0},benhNgheNghieps: {soNguoi: 0, tongSoNgay: 0} ,tongSos: {soNguoi: 0, tongSoNgay: 0}, },

      ]
      baoCaoCoSoLaoDong.value.benhNgheNghiepDuocBhs = [
        {tenBenh: "Bệnh bụi phổi silic nghề nghiệp",phatBenhKhiKham: {tongSo: 0, nu: 0},duocChanDoanBenh: {tongSo: 0, nu: 0},duocGiamDinh: {tongSo: 0, nu: 0},ketQuaDuoi5: {tongSo: 0, nu: 0},ketQuaTu5Den30: {tongSo: 0, nu: 0},ketQuaTren31: {tongSo: 0, nu: 0} },
        {tenBenh: "Bệnh bụi phổi bông nghề nghiệp",phatBenhKhiKham: {tongSo: 0, nu: 0},duocChanDoanBenh: {tongSo: 0, nu: 0},duocGiamDinh: {tongSo: 0, nu: 0},ketQuaDuoi5: {tongSo: 0, nu: 0},ketQuaTu5Den30: {tongSo: 0, nu: 0},ketQuaTren31: {tongSo: 0, nu: 0} },
        {tenBenh: "Bệnh viêm phế quản mạn tính nghề nghiệp",phatBenhKhiKham: {tongSo: 0, nu: 0},duocChanDoanBenh: {tongSo: 0, nu: 0},duocGiamDinh: {tongSo: 0, nu: 0},ketQuaDuoi5: {tongSo: 0, nu: 0},ketQuaTu5Den30: {tongSo: 0, nu: 0},ketQuaTren31: {tongSo: 0, nu: 0} },
        {tenBenh: "Bệnh điếc nghề nghiệp do tiếng ồn",phatBenhKhiKham: {tongSo: 0, nu: 0},duocChanDoanBenh: {tongSo: 0, nu: 0},duocGiamDinh: {tongSo: 0, nu: 0},ketQuaDuoi5: {tongSo: 0, nu: 0},ketQuaTu5Den30: {tongSo: 0, nu: 0},ketQuaTren31: {tongSo: 0, nu: 0} },
        {tenBenh: "Bệnh nghề nghiệp do rung toàn thân",phatBenhKhiKham: {tongSo: 0, nu: 0},duocChanDoanBenh: {tongSo: 0, nu: 0},duocGiamDinh: {tongSo: 0, nu: 0},ketQuaDuoi5: {tongSo: 0, nu: 0},ketQuaTu5Den30: {tongSo: 0, nu: 0},ketQuaTren31: {tongSo: 0, nu: 0} },
        {tenBenh: "Bệnh sạm da nghề nghiệp",phatBenhKhiKham: {tongSo: 0, nu: 0},duocChanDoanBenh: {tongSo: 0, nu: 0},duocGiamDinh: {tongSo: 0, nu: 0},ketQuaDuoi5: {tongSo: 0, nu: 0},ketQuaTu5Den30: {tongSo: 0, nu: 0},ketQuaTren31: {tongSo: 0, nu: 0} },
        {tenBenh: "Bệnh da nghề nghiệp do tiếp xúc môi trường ẩm ướt và lạnh kéo dài",phatBenhKhiKham: {tongSo: 0, nu: 0},duocChanDoanBenh: {tongSo: 0, nu: 0},duocGiamDinh: {tongSo: 0, nu: 0},ketQuaDuoi5: {tongSo: 0, nu: 0},ketQuaTu5Den30: {tongSo: 0, nu: 0},ketQuaTren31: {tongSo: 0, nu: 0} },
      ]

      baoCaoCoSoLaoDong.value.danhSachTruongHopBenhNgheNghieps = [
        {tenBenhNhan: "", ngheKhiBiBenh: "", tuoiNghe: 0,tenBenh: "",tyLeSuyGiamKNLD: 0,congViecHienNay: "", },
        {tenBenhNhan: "", ngheKhiBiBenh: "", tuoiNghe: 0,tenBenh: "",tyLeSuyGiamKNLD: 0,congViecHienNay: "", },
        {tenBenhNhan: "", ngheKhiBiBenh: "", tuoiNghe: 0,tenBenh: "",tyLeSuyGiamKNLD: 0,congViecHienNay: "", },
      ]

      baoCaoCoSoLaoDong.value.tinhHinhBenhTatVaTnlds = [
        {nhomBenh: "Lao phổi (A15-A19)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Ung thư phổi (C34)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Viêm xoang, mũi họng, thanh quản cấp (J00-J06)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Viêm xoang, mũi họng, thanh quản mạn (J31-J37)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Viêm phế quản cấp (J05)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Viêm phế quản mạn (J41-J42)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Viêm phổi (J09-J18)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Hen phế quản, giãn phế quản, dị ứng (J45-J47)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Ỉa chảy, viêm dạ dày, ruột do NT (A00-A09)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Bệnh nội tiết (E15-E16, E20-E35)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Bệnh tâm thần (F00-F28)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Bệnh thần kinh tr/ương và ngoại biên (G60-G64)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Bệnh mắt (H53-H54)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Bệnh tai (H60-H62, H65-H75, H80-H83, H90-H95)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Bệnh tim mạch (I05-I15, I20-I25, I30-I52)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Bệnh dạ dày, tá tràng (K20-K31)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Bệnh gan, mật (K70-K77, K80-K87)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Bệnh thận, tiết niệu (N00-N08, N10-N19, N25- N29)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Bệnh phụ khoa/số nữ (N94.9)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Sảy thai/số nữ có thai (O02-O03)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Bệnh da (L00-L99)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Bệnh cơ, xương khớp (M60-M99)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Bệnh sốt rét (B50, B53)", sauThangDauNam: {}, sauThangCuoiNam: {} },
        {nhomBenh: "Các loại bệnh khác (Ghi rõ cụ thể)", sauThangDauNam: {}, sauThangCuoiNam: {} },
      ]

      baoCaoCoSoLaoDong.value.tinhHinhBenhTatMacBenhNN = [
        {nhomBenh: "Bệnh nghề nghiệp", sauThangDauNam: {}, sauThangCuoiNam: {} },
      ]
      baoCaoCoSoLaoDong.value.tinhHinhTnld = [
        {nhomBenh: "Tai nạn lao động", sauThangDauNam: {}, sauThangCuoiNam: {} },
      ]
      baoCaoCoSoLaoDong.value.phanLoaiSucKhoes = [
        {soNguoiDuocKSK: "Nam", tongSo: 0, loaiI: 0, loaiII: 0, loaiIII: 0, loaiIV: 0, loaiV: 0, },
        {soNguoiDuocKSK: "Tỷ lệ %", tongSo: 0, loaiI: 0, loaiII: 0, loaiIII: 0, loaiIV: 0, loaiV: 0, },
        {soNguoiDuocKSK: "Nữ", tongSo: 0, loaiI: 0, loaiII: 0, loaiIII: 0, loaiIV: 0, loaiV: 0, },
        {soNguoiDuocKSK: "Tỷ lệ %", tongSo: 0, loaiI: 0, loaiII: 0, loaiIII: 0, loaiIV: 0, loaiV: 0, },
        {soNguoiDuocKSK: "Tổng cộng", tongSo: 0, loaiI: 0, loaiII: 0, loaiIII: 0, loaiIV: 0, loaiV: 0, },
        {soNguoiDuocKSK: "Tỷ lệ %", tongSo: 0, loaiI: 0, loaiII: 0, loaiIII: 0, loaiIV: 0, loaiV: 0, },
      ]

      baoCaoCoSoLaoDong.value.congTacHuanLuyens = [
        {noiDungHuanLuyen: "Huấn luyện về sơ cấp cứu cho người lao động", tongSo: 0, soNu: 0 },
        {noiDungHuanLuyen: "Huấn luyện về an toàn lao động", tongSo: 0, soNu: 0 },
        {noiDungHuanLuyen: "Huấn luyện SCCC cho lực lượng SCCC", tongSo: 0, soNu: 0 },
        {noiDungHuanLuyen: "Các nội dung huấn luyện khác(Ghi cụ thể)...", tongSo: 0, soNu: 0 },
      ]
      baoCaoCoSoLaoDong.value.kinhPhiChiTras = [
        {noiDungHoatDong: "Khám sức khỏe định kỳ", soTien: 0, ghiChu: "" },
        {noiDungHoatDong: "Khám phát hiện/khám định kỳ bệnh nghề nghiệp", soTien: 0, ghiChu: "" },
        {noiDungHoatDong: "Huấn luyện an toàn vệ sinh lao động, sơ cứu, cấp cứu", soTien: 0, ghiChu: "" },
        {noiDungHoatDong: "Quan trắc môi trường lao động", soTien: 0, ghiChu: "" },
        {noiDungHoatDong: "Bồi thường tai nạn lao động, bệnh nghề nghiệp", soTien: 0, ghiChu: "" },
        {noiDungHoatDong: "Chi phí điều trị các bệnh thông thường tại CSLĐ", soTien: 0, ghiChu: "" },
        {noiDungHoatDong: "Chi phí liên quan khác", soTien: 0, ghiChu: "" },
      ]
    }
    initDb();

    const addThongTin = () => {
      baoCaoCoSoLaoDong.value.thongTinLaoDongs.push({hoVaTen:""});
    }
    const addKiemTra = () => {
      baoCaoCoSoLaoDong.value.kiemTraVeSinhLaoDongs.push({donViKiemTra:""});
    }
    const addDieuKien = () => {
      baoCaoCoSoLaoDong.value.dieuKienLaoDongs.push({yeuToQuanTrac:"", tongSoMaus: {bui: false}, soMauKhongDats: {bui: false},});
    }
    const addBenhBH = () => {
      baoCaoCoSoLaoDong.value.benhNgheNghiepDuocBhs.push( {tenBenh: "",phatBenhKhiKham: {tongSo: 0, nu: 0},duocChanDoanBenh: {tongSo: 0, nu: 0},duocGiamDinh: {tongSo: 0, nu: 0},ketQuaDuoi5: {tongSo: 0, nu: 0},ketQuaTu5Den30: {tongSo: 0, nu: 0},ketQuaTren31: {tongSo: 0, nu: 0} },
      );  }

    const addBenhNN = () => {
      baoCaoCoSoLaoDong.value.danhSachTruongHopBenhNgheNghieps.push({tenBenhNhan: "", ngheKhiBiBenh: "", tuoiNghe: 0,tenBenh: "",tyLeSuyGiamKNLD: 0,congViecHienNay: "", },
      );
    }
    const addBenhTNLD = () => {
      baoCaoCoSoLaoDong.value.tinhHinhBenhTatVaTnlds.push({nhomBenh: "", sauThangDauNam: {}, sauThangCuoiNam: {} },
      );
    }

    const addReport = () => {
      if(baoCaoCoSoLaoDong.value.thoiGianBC == null)
      {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Vui lòng chọn thời gian báo cáo',
          life: 2000
        });
      }
      else {
        CDCRepository.createBaoCaoYTeLaoDong(baoCaoCoSoLaoDong.value)
            .then((response) => {
              const temp = ref({} as BaoCaoCoSoLaoDong);
              baoCaoCoSoLaoDong.value = temp.value;
              initDb();
              toast.add({
                severity: 'success',
                summary: 'Thêm báo cáo',
                detail: 'Thêm báo cáo thành công vào hệ thống',
                life: 2000
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
      }
    }

    const dateLaoDong= ref();
    const selectCalendarLaoDong= () => {
      if((dateLaoDong.value[0] != null)&&(dateLaoDong.value[1] != null))
      {
        listBaoCao.value = [];
        CDCRepository.getListBaoCaoYTeTruongHoc(dateLaoDong.value[0]/1000, dateLaoDong.value[1]/1000)
            .then((response) => {
              listBaoCao.value = response.data;
              if(listBaoCao.value.length < 1){
                toast.add({
                  severity: 'warn',
                  summary: 'Báo cáo',
                  detail:'Không tìm thấy báo cáo trong khoản thời gian đã chọn',
                  life: 2500
                })
              }
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })})
      }
    };

    const clearCalendar = () => {
      listBaoCao.value = [];
    }
    const formatDateTime = (date) => {
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format(' MM/YYYY');
    };

    const downLoadFileExport = (id) => {
      const file = ref("");
      // if(id == 3)
      // {
      file.value = "MaubaocaoYTTH.doc";
      // }
      // else
      // {
      //   file.value = "bcld2.doc";
      // }
      axios({
        url: '../api/cdc/downloadLoadFileReport/' + file.value,
        method: 'GET',
        responseType: 'blob',
      })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "MaubaocaoYTTH.doc");
            toast.add({
              severity: 'success',
              summary: 'Xuất dữ liệu',
              detail: 'Xuất dữ liệu thành công',
              life: 2000
            });
            document.body.appendChild(link);
            link.click();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    };

    return {
      date,
      service,
      baoCaoCoSoLaoDong,
      addThongTin,
      addKiemTra,
      addDieuKien,
      addBenhBH,
      addBenhNN,
      addReport,
      addBenhTNLD,
      selectCalendarLaoDong,
      listBaoCao,
      dateLaoDong,
      clearCalendar,
      formatDateTime,
      downLoadFileExport,
    }
  }

}
